import { socialLinks } from "../data";
import SocialLink from "./SocialLink";

const Footer = () => {
  return (
    <footer className='section footer' id='contact'>
      <ul className='footer-links'>
      
      </ul>
      <ul className='footer-icons'>
        
        {socialLinks.map((socialLink) => {
          return ( 
          <> 
          <div  className="contact">
          <h4 className="contact-content">Call Us on 0243417251 </h4>
          .............................................................................................
          <h4 className="contact-content"> Whatsapp Us  </h4>  
          <span> 
            <SocialLink
              key={socialLink.id}
              {...socialLink}
              itemClass='footer-icon'
            /></span>
          </div>
          
            </>
          );
        })}
      </ul>
      <p className='copyright'>
        copyright &copy; TechSolu IT Consultancy Firm
        <span id='date'>{new Date().getFullYear()}</span> all rights reserved
      </p>
    </footer>
  );
};
export default Footer;
